module.exports = __webpack_public_path__ + "img/2-ob1.a9726802.png";